(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6564],{

/***/ 96734:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Content021": function() { return /* binding */ Content021; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var shared_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(87900);
/* harmony import */ var shared_hooks__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(87367);
/* harmony import */ var shared_utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(63414);
/* harmony import */ var _Content021_module_scss__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(95529);
/* harmony import */ var _Content021_module_scss__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_Content021_module_scss__WEBPACK_IMPORTED_MODULE_4__);





var Content021 = function(param) {
    var payload = param.payload;
    var ref;
    var title = (ref = payload === null || payload === void 0 ? void 0 : payload.title) !== null && ref !== void 0 ? ref : "";
    var ref1;
    var subtitle = (ref1 = payload === null || payload === void 0 ? void 0 : payload.subtitle) !== null && ref1 !== void 0 ? ref1 : "";
    var ref2;
    var description = (ref2 = payload === null || payload === void 0 ? void 0 : payload.description) !== null && ref2 !== void 0 ? ref2 : "";
    var ref3;
    var videoLink = ((ref3 = payload === null || payload === void 0 ? void 0 : payload.videoLink) !== null && ref3 !== void 0 ? ref3 : null).videoLink;
    var ref4;
    var buttonText = ((ref4 = payload === null || payload === void 0 ? void 0 : payload.videoLink) !== null && ref4 !== void 0 ? ref4 : "").buttonText;
    var videoId = (0,shared_utils__WEBPACK_IMPORTED_MODULE_3__/* .parseYouTubeId */ .Us)(videoLink);
    var ref5 = (0,shared_hooks__WEBPACK_IMPORTED_MODULE_2__/* .useToggle */ .OT)(), opened = ref5.opened, onOpen = ref5.onOpen, onClose = ref5.onClose;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: (_Content021_module_scss__WEBPACK_IMPORTED_MODULE_4___default().wrapper),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(shared_components__WEBPACK_IMPORTED_MODULE_1__/* .Container */ .W2, {
            className: (_Content021_module_scss__WEBPACK_IMPORTED_MODULE_4___default().inner),
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(shared_components__WEBPACK_IMPORTED_MODULE_1__/* .Heading3 */ .aC, {
                    className: (_Content021_module_scss__WEBPACK_IMPORTED_MODULE_4___default().title),
                    children: title
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: (_Content021_module_scss__WEBPACK_IMPORTED_MODULE_4___default().content),
                    children: [
                        videoId && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(shared_components__WEBPACK_IMPORTED_MODULE_1__/* .Action */ .aU, {
                            onClick: onOpen,
                            className: (_Content021_module_scss__WEBPACK_IMPORTED_MODULE_4___default().button),
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                    className: (_Content021_module_scss__WEBPACK_IMPORTED_MODULE_4___default().play),
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(shared_components__WEBPACK_IMPORTED_MODULE_1__/* .Icon */ .JO, {
                                        className: (_Content021_module_scss__WEBPACK_IMPORTED_MODULE_4___default().icon),
                                        name: "arrow_right"
                                    })
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(shared_components__WEBPACK_IMPORTED_MODULE_1__/* .Paragraph */ .nv, {
                                    color: "brand",
                                    className: (_Content021_module_scss__WEBPACK_IMPORTED_MODULE_4___default()["button-text"]),
                                    appearance: "bigger",
                                    children: buttonText
                                })
                            ]
                        }),
                        opened && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(shared_components__WEBPACK_IMPORTED_MODULE_1__/* .ModalWrapper */ .AB, {
                            onCloseModal: onClose,
                            appearance: "full-area",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(shared_components__WEBPACK_IMPORTED_MODULE_1__/* .YoutubeVideo */ .tL, {
                                id: videoId
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: (_Content021_module_scss__WEBPACK_IMPORTED_MODULE_4___default().text),
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(shared_components__WEBPACK_IMPORTED_MODULE_1__/* .Heading5 */ .by, {
                                    className: (_Content021_module_scss__WEBPACK_IMPORTED_MODULE_4___default().subtitle),
                                    children: subtitle
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(shared_components__WEBPACK_IMPORTED_MODULE_1__/* .Paragraph */ .nv, {
                                    color: "dark",
                                    children: description
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["default"] = (Content021);


/***/ }),

/***/ 95529:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Content021_wrapper__TjC__","content":"Content021_content__iuYTU","title":"Content021_title__cUUcS","text":"Content021_text__gkGkM","subtitle":"Content021_subtitle__4KPP8","button":"Content021_button__3JKDx","play":"Content021_play__Fwhc6","icon":"Content021_icon__6Zls1","button-text":"Content021_button-text__bHGUE"};

/***/ })

}]);